import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import addressFormatter from './transformers/address';
import { LocationPropType } from './proptypes';

const OrganizationSchema = ({ siteUrl, images, name, logo, address }) => {
  const featuredImage = images.length > 0 ? images[0] : null;

  const data = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name,
    url: siteUrl,
    logo,
    image: featuredImage,
    address: addressFormatter(address),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default OrganizationSchema;

OrganizationSchema.propTypes = {
  siteUrl: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string.isRequired,
  logo: PropTypes.string,
  address: PropTypes.oneOfType([
    PropTypes.string,
    LocationPropType,
    PropTypes.arrayOf(LocationPropType),
  ]),
};

OrganizationSchema.defaultProps = {
  siteUrl: null,
  images: [],
  logo: '',
  address: '',
};
